<template>
  <select class="mb-2 select-component" @change="onChangeHandler">
    <option>--Please choose an option--</option>
    <option v-for="(option, index) in content.options" :key="index" :value="option">{{option}}</option>
  </select>
</template>

<script>
    import "bootstrap"
    export default {
        name: "SelectComponent",
        props:{
            content: Object,
            idx: Number,
        },
        data(){
            return {
                response : null
            }
        },
        methods : {
            onChangeHandler : function (event) {
                console.log(event.target)
                this.$emit('responseevent', {id: this.$props.idx, response: event.target.value})
            }
        }
    }
</script>

<style scoped src="../assets/bootstrap.min.css"></style>